export default __webpack_public_path__ + "static/media/amnet-logo.6b9eeebf.svg";